import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { WatchLiveButtonWrapper, StreamIconButtonWrapper } from './WatchLiveButton.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    children: string | JSX.Element;
    className?: string;
    onClick?: () => void;
    isDisabled?: boolean;
    streamOn?: boolean;
}

export const WatchLiveButton = observer(
    'WatchLiveButton',
    ({ children, className, onClick, isDisabled, streamOn }: PropsType): JSX.Element => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        return (
            <WatchLiveButtonWrapper
                className={className}
                onClick={onClick}
                isDisabled={isDisabled}
                streamOn={streamOn}
                variant={configState.componentVariants.sportsbookVariant}
            >
                <StreamIconButtonWrapper isDisabled={isDisabled} />
                {children}
            </WatchLiveButtonWrapper>
        );
    }
);
